import React from "react"
import { requestConfirmIncentive } from "../../../actions/incentiveList"
import { Button } from "@mantine/core"
import { State } from "../../../reducers"
import { bindActionCreators, Dispatch } from "redux"
import { connect } from "react-redux"
import { confirmIssueIncentive } from "../../../utils/confirm"

interface OwnProps {
  clientId: number
  selectedTokeys: string[]
}

interface StateProps {
  matchedTokeys: string[]
  csvFriendEmails: Record<string, string>
  loading: boolean
}

interface DispatchProps {
  requestConfirmIncentive: typeof requestConfirmIncentive
}

type Props = OwnProps & StateProps & DispatchProps

// 特典付与代行リスト 発行確定ボタン
// チェック済みtokeyを発行済みにし、次回照合の対象外にする
const IncentiveConfirmButtonComponent: React.FC<Props> = ({
  clientId,
  selectedTokeys,
  matchedTokeys,
  csvFriendEmails,
  loading,
  requestConfirmIncentive,
}) => {
  const handleConfirm = () => {
    if (selectedTokeys.length === 0) return
    if (!confirmIssueIncentive(selectedTokeys.length)) return
    requestConfirmIncentive(clientId, selectedTokeys, matchedTokeys, csvFriendEmails)
  }

  return (
    <Button
      variant="filled"
      radius="xl"
      size="sm"
      onClick={handleConfirm}
      disabled={selectedTokeys.length === 0 || loading}
      loading={loading}
    >発行確定</Button>
  )
}

const mapStateToProps = (state: State): StateProps => ({
  matchedTokeys: state.incentiveList.matchedTokeys || [],
  csvFriendEmails: state.incentiveList.csvFriendEmails || {},
  loading: state.incentiveList.loading,
})

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps =>
  bindActionCreators({ requestConfirmIncentive }, dispatch as any)

export const IncentiveConfirmButton = connect(
  mapStateToProps,
  mapDispatchToProps,
)(IncentiveConfirmButtonComponent as any) as any as React.ComponentType<OwnProps>
